/* A&Y — cadeaux offerts (v8) : choix avec photos sur la fiche produit, dans le tiroir panier et sur la page panier.
   - Une photo touchée (puis la couleur ou la taille) = cadeau enregistré dans le panier, sans autre bouton :
     attributs « Cadeau 1 » / « Cadeau 2 », au format « Titre — Variante [id] » attendu pour la préparation.
   - Fiche produit : si le panier n'est pas encore admissible, le choix est gardé puis enregistré au moment de
     « Ajouter au panier » (un seul clic). La propriété de ligne « Cadeau offert » accompagne aussi Shop Pay.
   - Paliers : 50 $ = 1 MINUS · 100 $ = 2 MINUS · 150 $ = Tout Doux (Cadeau 1) + MINUS (Cadeau 2) · 200 $ = pass VIP.
   - Rien n'est obligatoire : on peut toujours passer à la caisse sans choisir (A&Y choisit alors). */
(() => {
  'use strict';
  const en = document.documentElement.lang.startsWith('en');
  const routes = window.ayRoutes || {};
  const rootPath = String(routes.root || '/');
  const base = rootPath.endsWith('/') ? rootPath : rootPath + '/';
  const T1 = 5000, T2 = 10000, T3 = 15000, VIP = 20000;
  const VIP_VALUE = '3 mois · 20 % · livraison standard offerte';
  const PROP = 'properties[Cadeau offert]';
  const money = cents => (window.ayMoney ? window.ayMoney(cents) : new Intl.NumberFormat(en ? 'en-CA' : 'fr-CA', { style: 'currency', currency: 'CAD' }).format(cents / 100));
  const L = en ? {
    lockedTitle: '🎁 A free MINUS gift from $50',
    locked: amount => `Add ${amount} more to your cart to choose one of these gifts.`,
    openTitle: '🎁 Your free MINUS gift',
    openPdp: 'Your order reaches $50: choose your gift below. It is added to your order, no second step.',
    openPdpCart: 'With your cart, your order reaches $50: choose your gift below. It is added with “Add to cart”.',
    second: 'Second gift (orders of $100+): choose it in your cart.',
    vipTitle: '🎁 3-month VIP pass included',
    vip: 'Orders of $200+: 20% off each order and free standard shipping for 3 months. A&Y activates it after purchase.',
    drawerTitle: n => (n > 1 ? '🎁 Your free gifts' : '🎁 Your free gift'),
    drawerText: 'Tap a photo: your gift is added to your order right away.',
    slot: (n, name) => `Gift ${n} · ${name}`,
    pick: 'Choose the colour or size:',
    pickSelect: 'Choose…',
    chosen: 'Your gift',
    added: '✓ Added to your order',
    pending: '✓ Selected: added with your item',
    saving: 'Saving…',
    change: 'Change',
    error: 'Your gift could not be saved. Please try again, or write it in the order notes.',
    fine: 'No choice? A&Y will pick one for you.',
    items: n => n + (n === 1 ? ' item' : ' items'),
    empty: 'empty for now'
  } : {
    lockedTitle: '🎁 Un cadeau MINUS offert dès 50 $',
    locked: amount => `Encore ${amount} dans votre panier et vous choisissez l’un de ces cadeaux.`,
    openTitle: '🎁 Votre cadeau MINUS offert',
    openPdp: 'Votre commande atteint 50 $ : choisissez votre cadeau ci-dessous. Il est ajouté à votre commande, sans étape de plus.',
    openPdpCart: 'Avec votre panier, votre commande atteint 50 $ : choisissez votre cadeau ci-dessous. Il est ajouté avec « Ajouter au panier ».',
    second: '2e cadeau (commande de 100 $ et plus) : à choisir dans votre panier.',
    vipTitle: '🎁 Pass VIP 3 mois offert',
    vip: 'Commande de 200 $ et plus : 20 % sur chaque commande et livraison standard offerte pendant 3 mois. A&Y l’active après l’achat.',
    drawerTitle: n => (n > 1 ? '🎁 Vos cadeaux offerts' : '🎁 Votre cadeau offert'),
    drawerText: 'Touchez une photo : votre cadeau est ajouté tout de suite à votre commande.',
    slot: (n, name) => `Cadeau ${n} · ${name}`,
    pick: 'Choisissez la couleur ou la taille :',
    pickSelect: 'Choisir…',
    chosen: 'Votre cadeau',
    added: '✓ Ajouté à votre commande',
    pending: '✓ Sélectionné : ajouté avec votre article',
    saving: 'Enregistrement…',
    change: 'Changer',
    error: 'Le cadeau n’a pas pu être enregistré. Réessayez ou indiquez-le dans les notes de commande.',
    fine: 'Pas de choix ? A&Y en sélectionnera un pour vous.',
    items: n => n + (n === 1 ? ' article' : ' articles'),
    empty: 'vide pour l’instant'
  };

  /* ---------- Outils ---------- */
  const el = (tag, cls, txt) => { const n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; };
  const idOf = value => { const v = String(value || '').trim(); const i = v.lastIndexOf('['); if (i < 0 || v.slice(-1) !== ']') return ''; const id = v.slice(i + 1, -1); return /^[0-9]+$/.test(id) ? id : ''; };
  const isMinus = v => /MINUS/i.test(v || '');
  const isDoux = v => /Tout Doux/i.test(v || '');
  const valueOf = (p, v) => `${p.f} — ${v[1]} [${v[0]}]`;
  const labelOf = (p, v) => (v[1] && v[1] !== 'Default Title' ? `${p.t} — ${v[1]}` : p.t);
  const parseCatalog = node => { try { return node ? JSON.parse(node.textContent) : null; } catch (_) { return null; } };
  const findSaved = (products, value) => {
    const id = idOf(value);
    if (!id) return null;
    for (const p of products) { const v = p.v.find(x => String(x[0]) === id); if (v) return { p, v }; }
    return null;
  };
  const slotsFor = total => (total >= VIP ? []
    : total >= T3 ? [{ key: 'Cadeau 1', coll: 'doux' }, { key: 'Cadeau 2', coll: 'minus' }]
    : total >= T2 ? [{ key: 'Cadeau 1', coll: 'minus' }, { key: 'Cadeau 2', coll: 'minus' }]
    : total >= T1 ? [{ key: 'Cadeau 1', coll: 'minus' }] : []);
  /* Mêmes règles que snippets/ay-maison-gifts.liquid : chaque choix retrouve l'emplacement de sa collection. */
  function resolve(total, attrs) {
    const s1 = attrs['Cadeau 1'] || '', s2 = attrs['Cadeau 2'] || '';
    let v1 = '', v2 = '';
    if (total >= VIP) { v1 = s1; v2 = s2; }
    else if (total >= T3) { v1 = isDoux(s1) ? s1 : isDoux(s2) ? s2 : ''; v2 = isMinus(s2) ? s2 : isMinus(s1) ? s1 : ''; }
    else if (total >= T2) { const m = [s1, s2].filter(isMinus); v1 = m[0] || ''; v2 = m[1] || ''; }
    else if (total >= T1) { v1 = isMinus(s1) ? s1 : isMinus(s2) ? s2 : ''; }
    return { 'Cadeau 1': v1, 'Cadeau 2': v2, 'Pass VIP demandé': total >= VIP ? VIP_VALUE : '' };
  }
  const differs = (wanted, attrs) => Object.keys(wanted).some(k => (wanted[k] || '') !== (attrs[k] || ''));
  const minusKey = total => (total >= T3 ? 'Cadeau 2' : 'Cadeau 1');

  /* ---------- Panier (une seule file d'attente pour ne jamais se marcher dessus) ---------- */
  let queue = Promise.resolve();
  const enqueue = task => { const run = queue.catch(() => {}).then(task); queue = run; return run; };
  const getCart = () => fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
    .then(r => { if (!r.ok) throw new Error('cart'); return r.json(); });
  async function postAttributes(attributes, source) {
    const r = await fetch(base + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes }) });
    if (!r.ok) throw new Error('save');
    const cart = await r.json();
    document.dispatchEvent(new CustomEvent('ay:gifts:saved', { detail: { cart, source } }));
    return cart;
  }
  const saveAttributes = (attributes, source) => enqueue(() => postAttributes(attributes, source));

  /* ---------- Sélecteur avec photos ---------- */
  function Picker(opts) {
    const wrap = el('div', 'ay-gifts__slot');
    if (opts.label) wrap.append(el('p', 'ay-gifts__label', opts.label));
    const chosen = el('div', 'ay-gifts__chosen');
    const list = el('div', 'ay-gifts__list');
    const variants = el('div', 'ay-gifts__variants');
    const status = el('p', 'ay-gifts__status ay-gifts__error');
    status.setAttribute('role', 'status');
    chosen.hidden = true; variants.hidden = true; status.hidden = true;
    wrap.append(chosen, list, variants, status);
    const cards = new Map();
    if (opts.preview) { list.classList.add('is-preview'); list.setAttribute('aria-hidden', 'true'); }
    else { list.setAttribute('role', 'radiogroup'); list.setAttribute('aria-label', opts.label || L.chosen); }
    (opts.products || []).forEach(p => {
      const card = el(opts.preview ? 'span' : 'button', 'ay-gifts__card');
      if (!opts.preview) {
        card.type = 'button';
        card.setAttribute('role', 'radio');
        card.setAttribute('aria-checked', 'false');
        card.addEventListener('click', () => choose(p));
      }
      const img = el('img');
      img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = 72; img.height = 72;
      if (p.img) img.src = p.img;
      card.append(img, el('span', 'ay-gifts__name', p.t));
      cards.set(p, card);
      list.append(card);
    });
    const mark = p => cards.forEach((card, q) => { if (card.tagName === 'BUTTON') card.setAttribute('aria-checked', String(q === p)); });
    function showChosen(p, v, state) {
      const img = el('img');
      img.alt = ''; img.width = 52; img.height = 52; img.loading = 'lazy';
      if (p.img) img.src = p.img;
      const txt = el('div', 'ay-gifts__chosen-text');
      txt.append(el('span', 'ay-gifts__chosen-k', L.chosen), el('strong', '', labelOf(p, v)));
      if (state) txt.append(el('span', 'ay-gifts__ok', state));
      const change = el('button', 'ay-gifts__change', L.change);
      change.type = 'button';
      change.addEventListener('click', () => {
        chosen.hidden = true; list.hidden = false; variants.hidden = true; status.hidden = true;
        const card = cards.get(p);
        if (card) { card.focus({ preventScroll: true }); list.scrollLeft = Math.max(0, card.offsetLeft - 8); }
      });
      chosen.replaceChildren(img, txt, change);
      chosen.hidden = false; list.hidden = true; variants.hidden = true;
    }
    async function commit(p, v) {
      status.hidden = true;
      showChosen(p, v, L.saving);
      try {
        const state = await opts.onPick(valueOf(p, v), p, v);
        showChosen(p, v, state || L.added);
      } catch (_) {
        chosen.hidden = true; list.hidden = false;
        status.textContent = L.error; status.hidden = false;
      }
    }
    function choose(p) {
      mark(p);
      status.hidden = true;
      if (p.v.length === 1) { variants.hidden = true; commit(p, p.v[0]); return; }
      variants.replaceChildren(el('p', 'ay-gifts__pick', L.pick));
      if (p.v.length > 8) {
        const select = el('select', 'ay-gifts__select');
        select.setAttribute('aria-label', L.pick);
        select.append(new Option(L.pickSelect, ''));
        p.v.forEach(v => select.append(new Option(v[1], String(v[0]))));
        select.addEventListener('change', () => { const v = p.v.find(x => String(x[0]) === select.value); if (v) commit(p, v); });
        variants.append(select);
      } else {
        const chips = el('div', 'ay-gifts__chips');
        p.v.forEach(v => {
          const chip = el('button', 'ay-gifts__chip', v[1]);
          chip.type = 'button';
          chip.addEventListener('click', () => commit(p, v));
          chips.append(chip);
        });
        variants.append(chips);
      }
      variants.hidden = false;
    }
    if (!opts.preview && opts.saved) {
      const found = findSaved(opts.products || [], opts.saved);
      if (found) { mark(found.p); showChosen(found.p, found.v, opts.savedState || ''); }
    }
    return wrap;
  }

  /* ---------- Catalogue (sur la page, sinon chargé une fois par session) ---------- */
  let fullCatalog = null;
  async function loadCatalog(needDoux) {
    const inline = [...document.querySelectorAll('[data-ay-gift-catalog]')].map(parseCatalog).find(c => c && Array.isArray(c.minus) && (!needDoux || Array.isArray(c.doux)));
    if (inline) return inline;
    if (fullCatalog) return fullCatalog;
    const cacheKey = 'ay-gift-catalog-v8-' + (routes.locale || 'fr');
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && cached.t > Date.now() - 30 * 60 * 1000 && cached.data && cached.data.doux) return (fullCatalog = cached.data);
    } catch (_) {}
    const r = await fetch(base + '?sections=ay-gift-catalog', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('catalog');
    const html = (await r.json())['ay-gift-catalog'] || '';
    const data = parseCatalog(new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ay-gift-catalog]'));
    if (!data || !Array.isArray(data.minus)) throw new Error('catalog');
    fullCatalog = data;
    try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), data })); } catch (_) {}
    return data;
  }

  window.ayGifts = { eligible: cart => Math.max(0, (Number(cart && cart.total_price) || 0) - ((cart && cart.items) || []).reduce((s, i) => s + (String(i.vendor || '').toLowerCase().trim() === 'morpheïa' ? Number(i.final_line_price) || 0 : 0), 0)), en, base, T1, T2, T3, VIP, PROP, money, L, el, isMinus, labelOf, parseCatalog, findSaved, slotsFor, resolve, differs, minusKey, enqueue, getCart, postAttributes, saveAttributes, idle: () => queue.catch(() => {}), Picker, loadCatalog };
})();